<template>
  <span>{{ data == null ? "" : data.name }}</span>
</template>

<script>
import * as psndoc from "@/api/base/psndoc";

export default {
  name: "EspPsndocView",
  data() {
    return {
      data: {}
    }
  },
  props: {
    pk: {
      type: String,
      default: ""
    }
  },
  methods: {
    /**
     * 查询数据
     */
    doLoadData: function () {
      if (this.pk) {
        psndoc.get(this.pk).then(resp => {
          this.data = resp.data;
        }).catch(error => {
        });
      } else {
        this.data = {};
      }
    }
  },
  watch: {
    pk: {
      handler: function (newVal, oldVal) {
        this.doLoadData();
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/psndoc/EspPsndocView.vue